import React from 'react';
import { TranslationUtils } from '../../utils';
import './ReceiptMor.scss';
import { Guests } from 'guest-data-types-ts-lib';

interface ReceiptBillingAddressProps {
    consumer_protection_bc: any;
    guests: Guests;
}

export const ReceiptBillingAddress: React.FC<ReceiptBillingAddressProps> = (props) => {
    const { consumer_protection_bc, guests } = props;
    const { billing_address } = consumer_protection_bc;
    let guestName;
    if (billing_address.first_name || billing_address.last_name) {
        guestName = `${billing_address.first_name} ${billing_address.last_name}`;
    } else {
        guestName = `${guests.primary.first_name} ${guests.primary.last_name}`;
    }
    return (
        <div id="items-summary" className="billing-address">
            <div className="col-md-4 col-xs-6">
                {!billing_address ? (
                    ''
                ) : (
                    <span tabIndex={0} className="billing-address-title">
                        {TranslationUtils.get('billing_address')}
                    </span>
                )}
                <p tabIndex={0} className="billing-address-detail">
                    {guestName}
                    <div className="mb-1"></div>
                    {!billing_address.address_1 ? '' : billing_address.address_1}
                    <div className="mb-1"></div>
                    {!billing_address.address_2 ? '' : billing_address.address_2}
                    <div className="mb-1"></div>
                    {!billing_address.city ? '' : billing_address.city} {!billing_address.state ? '' : billing_address.state}{' '}
                    {!billing_address.zip ? '' : billing_address.zip}
                    {billing_address.country ? `, ${billing_address.country}` : ''}
                </p>
            </div>
        </div>
    );
};
